import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyLabManagementServices = {
  //Lab Management Column
  addNewStudyLabManagementColumn,
  updateStudyLabManagementColumnData,
  deleteStudyLabManagementColumnData,
  softDeleteRestoreStudyLabManagementColumn,
  getStudyLabManagementColumnData,
  
  //Lab Management Row
  addNewStudyLabManagementRow,
  updateStudyLabManagementRowData,
  deleteStudyLabManagementRowData,
  softDeleteRestoreStudyLabManagementRow,
  getStudyLabManagementRowData,
  
  //Study Site Lab
  addNewStudySiteLab,
  updateStudySiteLab,
  deleteStudySiteLab,
  softDeleteRestoreStudySiteLab,
  getStudySiteLab,
};

// Get Study Lab Management Column
async function getStudyLabManagementColumnData(status, studyId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLabManagementColumnData/${status}/${studyId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLabManagementColumnData/${status}/${studyId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Lab Management Column
async function addNewStudyLabManagementColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyLabManagementColumn`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Lab Management Column
async function updateStudyLabManagementColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyLabManagementColumnData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Lab Management Column
async function softDeleteRestoreStudyLabManagementColumn(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyLabManagementColumn`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Lab Management Column
async function deleteStudyLabManagementColumnData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLabManagementColumnData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Lab Management Row
async function getStudyLabManagementRowData(status, studyId, siteId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLabManagementRow/${status}/${studyId}/${siteId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyLabManagementRow/${status}/${studyId}/${siteId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Lab Management Row
async function addNewStudyLabManagementRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudyLabManagementRow`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Lab Management Row
async function updateStudyLabManagementRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyLabManagementRowData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Lab Management Row
async function softDeleteRestoreStudyLabManagementRow(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudyLabManagementRow`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Lab Management Row
async function deleteStudyLabManagementRowData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLabManagementRowData`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Get Study Site Lab
async function getStudySiteLab(status, studyId, siteId, searchData, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteLab/${status}/${studyId}/${siteId}?search=${searchData || ""}&page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudySiteLab/${status}/${studyId}/${siteId}?search=${searchData || ""}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add New Study Site Lab
async function addNewStudySiteLab(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStudySiteLab`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data;
}

// Update Study Site Lab
async function updateStudySiteLab(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudySiteLab`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Soft Delete & Restore Study Site Lab
async function softDeleteRestoreStudySiteLab(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStudySiteLab`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}

// Delete Study Site Lab
async function deleteStudySiteLab(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudySiteLab`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  handleResponse(data)
  return data
}